import { permissionKeys } from 'Global/permissionKeys'

const countSelected = (category, selectedPermissions) => {
  return Object.values(category).reduce((acc, cur) => {
    if (selectedPermissions.includes(cur.key)) {
      return acc + 1
    }

    return acc
  }, 0)
}

export const getCounts = selectedPermissions => {
  const general = {
    selected: countSelected(permissionKeys.general, selectedPermissions),
    total: Object.values(permissionKeys.general).length,
  }

  const modules = {
    selected: countSelected(permissionKeys.modules, selectedPermissions),
    total: Object.values(permissionKeys.modules).length,
  }

  const pictureActions = {
    selected: countSelected(permissionKeys.picture.action, selectedPermissions),
    total: Object.values(permissionKeys.picture.action).length,
  }

  const pictureFields = {
    selected: countSelected(permissionKeys.picture.field, selectedPermissions),
    total: Object.values(permissionKeys.picture.field).length,
  }

  const picturePictures = {
    selected: countSelected(permissionKeys.picture.picture, selectedPermissions),
    total: Object.values(permissionKeys.picture.picture).length,
  }

  const rugActions = {
    selected: countSelected(permissionKeys.rug.action, selectedPermissions),
    total: Object.values(permissionKeys.rug.action).length,
  }

  const rugFields = {
    selected: countSelected(permissionKeys.rug.field, selectedPermissions),
    total: Object.values(permissionKeys.rug.field).length,
  }

  const rugStatus = {
    selected: countSelected(permissionKeys.rug.status, selectedPermissions),
    total: Object.values(permissionKeys.rug.status).length,
  }

  const settings = {
    selected: countSelected(permissionKeys.settings, selectedPermissions),
    total: Object.values(permissionKeys.settings).length,
  }

  const familyAlbum = {
    selected: countSelected(permissionKeys.familyAlbum, selectedPermissions),
    total: Object.values(permissionKeys.familyAlbum).length,
  }

  const users = {
    selected: countSelected(permissionKeys.users, selectedPermissions),
    total: Object.values(permissionKeys.users).length,
  }

  const picture = {
    selected: pictureActions.selected + pictureFields.selected + picturePictures.selected,
    total: pictureActions.total + pictureFields.total + picturePictures.total,
  }

  const rug = {
    selected: rugActions.selected + rugFields.selected + rugStatus.selected,
    total: rugActions.total + rugFields.total + rugStatus.total,
  }

  return {
    familyAlbum,
    general,
    modules,
    picture,
    pictureActions,
    pictureFields,
    picturePictures,
    rug,
    rugActions,
    rugStatus,
    rugFields,
    settings,
    users,
    total: {
      selected:
        general.selected + modules.selected + picture.selected + rug.selected + settings.selected + familyAlbum.selected + users.selected,
      total: general.total + modules.total + picture.total + rug.total + settings.total + familyAlbum.total + users.total,
    },
  }
}
